import { Action } from "../../store/types";
import { Industry } from "../../models";
import * as actions from "./actions";
import { ProjectInfoFormValues } from "./components/ProjectInfoForm";

export interface Step4State {
  industries: Industry[];
  isDataLoading: boolean;
  useDefaultDimensions: boolean;
  // Places to store form values long-term away from redux-form control
  projectFormValues: ProjectInfoFormValues;
}

const initState: Step4State = {
  industries: [],
  isDataLoading: false,
  useDefaultDimensions: true,
  projectFormValues: {},
};

export default function(
  state = initState,
  { type, payload }: Action,
): Step4State {
  switch (type) {
    case actions.SET_INDUSTRIES:
      return { ...state, industries: payload };
    case actions.SET_DATA_LOADING:
      return { ...state, isDataLoading: payload };
    case actions.TOGGLE_DIMENSION:
      return { ...state, useDefaultDimensions: !state.useDefaultDimensions };
    case actions.SET_PROJECT_FORM_VALUES:
      return { ...state, projectFormValues: payload };
    case actions.RESET:
      return initState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/Step4/reducer.ts